import isVerifyTokenGuard from "@/guards/verifyTokenGuard";

export default {
    name: 'vaccination-record',
    component: () => import(/* webpackChunkName: "base-layout" */ '@/layouts/BaseLayout.vue'),
    children: [
        {
            path: '',
            name: 'patient-vaccination-record-index',
            beforeEnter: [isVerifyTokenGuard],
            meta: {
                breadcrumbs: [                   
                    {                           
                        transKey: 'breadcrumbs.vaccination-record-index',
                        isActive: true
                    }
                ]
            },
            component: () => import(/* webpackChunkName: "index-habits" */ '@/modules/patient-profile/vaccination-record/views/Create.vue')
        }
    ]
}